
const PRICE_OPMETING = 150;

export const calculate_price = (order) => {


    console.log(Object.keys(prijs_afmetingen_vliegramen))
    
    const w =order.DIMENSION.WIDTH //mm
    const h = order.DIMENSION.HEIGHT //mm


    const w_st = roundToNearest(w, Object.keys(prijs_afmetingen_vliegramen[500])) // mm
    const h_st = roundToNearest(h, Object.keys(prijs_afmetingen_vliegramen)) // mm


    const area = w*1 * h*1 / 1000000 // meters
    const aantal = order.AANTAL;

    const prijs_frame = prijs_afmetingen_vliegramen[h_st][w_st];
    const prijs_kleur = 0;
    const prijs_gaas_totaal = prijs_gaas[order.GAAS_TYPE]
    
    const totaal_prijs = (prijs_frame*1 + prijs_kleur*1 + prijs_gaas_totaal*1);

    console.log(prijs_frame)
    console.log(prijs_gaas_totaal)
    console.log(totaal_prijs)

    return ({...order, prijs: totaal_prijs})
}

export const calculate_total_price = (orders) => {
    const extra_opmeting = orders.find(o => o.OPMETING);
    const extra_opmeting_price = extra_opmeting ? PRICE_OPMETING : 0 ;
    const total_price = orders.reduce((total,p) => total + (p.AANTAL*1)*p.prijs, 0)*1 + extra_opmeting_price*1;
    return total_price
}

export const extra_opmeting_price = (orders) => {

    const extra_opmeting = orders.find(o => o.OPMETING);
    const price = extra_opmeting ? PRICE_OPMETING : 0 ;
    return price;
}


export const prijs_gaas = {
    SGG: 0, // Standaard Grijs Gaas
    SZG: 0, // Standaard Zwart Gaas
    BG: 5, // Gellavista Gaas - 5 euro / m2

    PG: 36.39, // Petscreen Grijs / ZWART
    PGG: 36.39, // Petscreen Grijs
    PGZ: 36.39, // Petscreen Zwart

    SD: 57.37, // Screendoek Grijs, Beige of Zwart
    SDG: 57.37, // Screendoek Grijs
    SDB: 57.37, // Screendoek Beige
    SDZ: 57.37, // Screendoek Zwart

    // ➢ screendoek door klant geleverd = + € 19,07/m² ==> Niet toegevoegd !

    IV:  101.08 // Inox Vliegengaas
}


export const prijs_afmetingen_vliegramen = {
    500: { 500: 33.62, 600: 35.78, 700: 37.95, 800: 40.08, 900: 42.24, 1000: 44.42, 1100: 46.57, 1200: 48.75, 1300: 50.93, 1400: 53.11, 1500: 55.29 },
    600: { 500: 35.35, 600: 37.51, 700: 39.64, 800: 41.82, 900: 43.98, 1000: 46.16, 1100: 48.27, 1200: 50.45, 1300: 52.62, 1400: 54.80, 1500: 56.98 },
    700: { 500: 37.08, 600: 39.23, 700: 41.37, 800: 43.55, 900: 45.72, 1000: 47.84, 1100: 50.01, 1200: 52.18, 1300: 54.36, 1400: 56.54, 1500: 58.72 },
    800: { 500: 38.79, 600: 40.96, 700: 43.11, 800: 45.28, 900: 47.40, 1000: 49.57, 1100: 51.74, 1200: 53.92, 1300: 56.10, 1400: 58.28, 1500: 60.46 },
    900: { 500: 40.51, 600: 42.69, 700: 44.84, 800: 47.01, 900: 49.13, 1000: 51.29, 1100: 53.47, 1200: 55.65, 1300: 57.83, 1400: 60.01, 1500: 62.18 },
    1000: { 500: 42.24, 600: 44.42, 700: 46.57, 800: 48.71, 900: 50.88, 1000: 53.02, 1100: 55.20, 1200: 57.38, 1300: 59.55, 1400: 61.73, 1500: 63.91 },
    1100: { 500: 43.98, 600: 46.16, 700: 48.27, 800: 50.44, 900: 52.60, 1000: 54.77, 1100: 56.88, 1200: 59.06, 1300: 61.24, 1400: 63.42, 1500: 65.59 },
    1200: { 500: 45.72, 600: 47.84, 700: 50.01, 800: 52.16, 900: 54.33, 1000: 56.47, 1100: 58.61, 1200: 60.79, 1300: 62.96, 1400: 65.14, 1500: 67.32 },
    1300: { 500: 47.40, 600: 49.57, 700: 51.88, 800: 53.90, 900: 56.03, 1000: 58.20, 1100: 60.35, 1200: 62.52, 1300: 64.70, 1400: 66.88, 1500: 69.06 },
    1400: { 500: 49.13, 600: 51.29, 700: 53.47, 800: 55.64, 900: 57.75, 1000: 59.93, 1100: 62.08, 1200: 64.26, 1300: 66.44, 1400: 68.62, 1500: 70.80 },
    1500: { 500: 50.88, 600: 53.02, 700: 55.20, 800: 57.33, 900: 59.49, 1000: 61.66, 1100: 63.81, 1200: 65.99, 1300: 68.17, 1400: 70.35, 1500: 72.52 },
    1600: { 500: 52.60, 600: 54.77, 700: 56.89, 800: 59.06, 900: 61.23, 1000: 63.38, 1100: 65.52, 1200: 67.69, 1300: 69.87, 1400: 72.05, 1500: 74.23 },
    1700: { 500: 54.33, 600: 56.47, 700: 58.61, 800: 60.79, 900: 62.95, 1000: 65.09, 1100: 67.25, 1200: 69.43, 1300: 71.61, 1400: 73.79, 1500: 75.97 },
    1800: { 500: 56.03, 600: 58.20, 700: 60.35, 800: 62.52, 900: 64.64, 1000: 66.81, 1100: 68.98, 1200: 71.16, 1300: 73.34, 1400: 75.52, 1500: 77.69 },
    1900: { 500: 57.75, 600: 59.93, 700: 62.08, 800: 64.26, 900: 66.37, 1000: 68.62, 1100: 70.71, 1200: 72.89, 1300: 75.06, 1400: 77.24, 1500: 79.42 },
    2000: { 500: 59.49, 600: 61.66, 700: 63.81, 800: 65.98, 900: 68.18, 1000: 70.28, 1100: 72.45, 1200: 74.62, 1300: 76.80, 1400: 78.98, 1500: 81.16 },
    2100: { 500: 61.23, 600: 63.38, 700: 65.52, 800: 67.67, 900: 69.84, 1000: 72.01, 1100: 74.13, 1200: 76.31, 1300: 78.49, 1400: 80.66, 1500: 82.84 },
    2200: { 500: 62.95, 600: 65.09, 700: 67.25, 800: 69.39, 900: 71.32, 1000: 73.70, 1100: 75.88, 1200: 78.06, 1300: 80.23, 1400: 82.41, 1500: 84.59 },
    2300: { 500: 64.64, 600: 66.81, 700: 68.99, 800: 71.14, 900: 73.28, 1000: 75.42, 1100: 77.61, 1200: 79.78, 1300: 81.96, 1400: 84.14, 1500: 86.32 },
    2400: { 500: 66.33, 600: 68.55, 700: 70.71, 800: 72.88, 900: 75.23, 1000: 77.15, 1100: 79.33, 1200: 81.51, 1300: 83.69, 1400: 85.87, 1500: 88.04 },
    2500: { 500: 68.02, 600: 70.28, 700: 72.45, 800: 74.62, 900: 77.18, 1000: 78.88, 1100: 81.06, 1200: 83.24, 1300: 85.42, 1400: 87.59, 1500: 89.77 },
  };
  


const roundToNearest = (value, availableSizes) => {
    // Converteer de keys naar getallen en zoek de dichtstbijzijnde
    const sizes = availableSizes.map(Number);
    return sizes.reduce((nearest, size) => 
      Math.abs(size - value) < Math.abs(nearest - value) ? size : nearest, sizes[0]);
  }
  